import { ComponentLookup } from '../ComponentLookup';
import { ElementState } from '@/elements/base/ElementState';
import { AttributeLookup } from './AttributeLookup';
import { ProductLookup } from '@/ui-kit/domain/lookup/ProductLookup';

export function componentLookupBehaviour(lookup: ComponentLookup, state: ElementState) {
  lookup.setValueSelectListener((visible) => {
    state.notify({
      event: 'changeComponentAttributesVisibility',
      visible,
      componentKey: lookup.componentKey,
      target: state,
    });
    state.notify({
      event: 'updateDependentAttributes',
      attributes: [],
      target: state,
    });
  });
}

export function attributeLookupBehaviour(lookup: AttributeLookup | ProductLookup, state: ElementState) {
  lookup.setValueSelectListener((_value) => {
    state.notify({
      event: 'updateDependentAttributes',
      attributes: [],
      target: state,
    });
  });
}
